import { Button as MuiButton } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Link } from 'react-router-dom';
import { useSelector } from '@client/hooks/redux.hooks';
import { getSessionUserState } from '@client/selectors/helpers/login';
import { openSignupModal } from '@client/components/Main/Signup';

interface SignupButtonProps {
  readonly id: string;
  readonly label?: string;
  readonly loggedInLabel?: string;
}

export const SignupButton: React.FC<SignupButtonProps> = ({ id, label = 'Sign Up. It\'s Free', loggedInLabel = 'Connect' }) => {
  const isLoggedIn = useSelector(getSessionUserState);

  const props = isLoggedIn ? {
    component: Link,
    to: '/connect',
  } : {
    onClick: () => openSignupModal(),
  };

  return (
    <MuiButton
      id={id}
      className="main-signup-button"
      endIcon={<ArrowForwardIcon />}
      variant="contained"
      color="secondary_dark"
      {...props}
    >
      {isLoggedIn ? loggedInLabel : label}
    </MuiButton>
  );
};
